import React from "react";
import "./ViewDetailsModal.css";

const ViewDetailsModal = ({ isOpen, onClose, title = "Details", rows = [] }) => {
  if (!isOpen) return null;

  return (
    <div className="details-modal-overlay" onClick={onClose}>
      <div className="details-modal" onClick={(e) => e.stopPropagation()}>
        <div className="details-modal-header">
          <h3>{title}</h3>
          <button
            type="button"
            className="details-modal-close"
            onClick={onClose}
            aria-label="Close"
          >
            ✕
          </button>
        </div>
        <div className="details-modal-body">
          <div className="details-grid">
            {rows.map(({ label, value }) => (
              <div className="detail-row" key={label}>
                <span className="detail-label">{label}</span>
                <span
                  className={`detail-value${
                    String(value ?? "").includes("\n")
                      ? " detail-value-multiline"
                      : ""
                  }`}
                >
                  {value !== undefined && value !== null && value !== ""
                    ? value
                    : "-"}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewDetailsModal;
